module.exports = __webpack_public_path__ + "img/cc6-can-we-cool-down.ac5cf542.jpg";